type Route42LogoVariant = 'lockup' | 'mark' | 'responsive';

export function Route42Logo({
  variant = 'lockup',
  className = '',
}: {
  variant?: Route42LogoVariant;
  className?: string;
}) {
  const classes = ['r42-logo', `r42-logo--${variant}`, className].filter(Boolean).join(' ');

  return (
    <span className={classes} role="img" aria-label="Route42">
      {variant !== 'mark' ? (
        <>
          <img
            className="r42-logo__lockup r42-logo__lockup--light-theme"
            src="/brand/route42-lockup-dark-text.png"
            width={1730}
            height={364}
            alt=""
            aria-hidden="true"
          />
          <img
            className="r42-logo__lockup r42-logo__lockup--dark-theme"
            src="/brand/route42-lockup-white-text.png"
            width={1730}
            height={364}
            alt=""
            aria-hidden="true"
          />
        </>
      ) : null}
      {variant !== 'lockup' ? (
        <img
          className="r42-logo__mark"
          src="/brand/route42-mark-color.png"
          width={653}
          height={653}
          alt=""
          aria-hidden="true"
        />
      ) : null}
    </span>
  );
}
